<template>
  <div>
    <div class="">
      <el-input v-model="iframeUrl" placeholder="请输入"></el-input>
    </div>

    <iframe
      allow="microphone; camera"
      :src="iframeUrl"
      width="100%"
      height="500px"
    ></iframe>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'IframeDemo',

  setup() {
    const iframeUrl = ref('')

    return {
      iframeUrl
    }
  }
})
</script>

<style lang="scss" scoped></style>
